import { getCoords } from '#utils/index';

const TEASER_DETAIL_WIDTH = 350;

export default function getTeaserDetailsPosition(hoverElement: HTMLElement) {
  const { centerX, centerY, right, left, width } = getCoords(hoverElement);

  //check if details don´t have enough space to the left or right and align them accordingly
  let offsetX = 0;

  if (centerX - TEASER_DETAIL_WIDTH / 2 < 0) {
    offsetX = Math.floor(TEASER_DETAIL_WIDTH / 2 - width / 2);
  }

  if (centerX + TEASER_DETAIL_WIDTH / 2 > window.innerWidth) {
    offsetX = Math.floor(TEASER_DETAIL_WIDTH / 2 - width / 2) * -1;
  }

  return {
    centerX: centerX + offsetX,
    centerY,
    right,
    left,
    width,
  };
}
